import Vue from 'vue';

export default {
    getSeekerClassifications() {
        const url = '/v1/site/classifications';
        return Vue.$axios.$get(url);
    },

    getClassificationSuggestions(context, params) {
        let url = 'v1/classification-suggestions';
        return Vue.$axios.$get(url, {params});
    },

};
